import { Component, OnInit, inject } from '@angular/core';
import {ReactiveFormsModule, UntypedFormBuilder, UntypedFormGroup, Validators} from "@angular/forms";
import {ActivatedRoute, Router} from "@angular/router";
import {DataService} from "../../services/data.service";
import {AccessService} from "../../services/access.service";
import {ToastrService} from "ngx-toastr";
import Swal from "sweetalert2";
import {ViewMode} from "../../interfaces";
import {NgForOf, NgIf} from "@angular/common";
import {InvoiceTypePipe} from "../../pipes/invoice-type.pipe";
import {DisableControlDirective} from "../../directives/disable-control.directive";

@Component({
    selector: 'app-invoice-type-detail',
    imports: [NgIf, ReactiveFormsModule, InvoiceTypePipe, NgForOf, DisableControlDirective],
    template: `
        <div class="card">
            <div class="card-body">
                <div class="mb-4">
                    <h3>
                        <i class="fa-solid fa-store me-2"></i>
                        @switch (viewMode) {
                            @case (ViewMode.INSERT) {
                                Rechnungskreis anlegen
                            }
                            @case (ViewMode.EDIT) {
                                Rechnungskreis bearbeiten
                            }
                            @case (ViewMode.VIEW) {
                                Rechnungskreis
                            }
                        }
                    </h3>
                </div>

                <form [formGroup]="form">
                    <div class="row g-3 mb-2">
                        <div class="col-6 col-lg-4">
                            <label>Bezeichnung</label>
                            <select class="form-control" formControlName="name" *ngIf="viewMode == ViewMode.INSERT">
                                <option value="" disabled selected style="display: none;">Bitte auswählen</option>
                                <option value="franchise">{{ 'franchise' | invoiceType }}</option>
                                <option value="recurring">{{ 'recurring' | invoiceType }}</option>
                                <option value="entry">{{ 'entry' | invoiceType }}</option>
                                <option value="various">{{ 'various' | invoiceType }}</option>
                                <option value="credit">{{ 'credit' | invoiceType }}</option>
                            </select>
                            <p *ngIf="viewMode != ViewMode.INSERT">{{ form.value.name | invoiceType }}</p>
                        </div>
                        @if (viewMode == ViewMode.INSERT) {
                            <div class="col-6 col-lg-4">
                                <label>Franchisegeber</label>
                                <select class="form-control" formControlName="id_franchisor" [disableControl]="form.controls.id_franchisee.value != ''">
                                    <option value="">Keine Auswahl</option>
                                    <option *ngFor="let franchisor of franchisors" [ngValue]="franchisor.id">
                                        {{ franchisor.name }}
                                    </option>
                                </select>
                            </div>
                            <div class="col-6 col-lg-4">
                                <label>Franchisenehmer</label>
                                <select class="form-control" formControlName="id_franchisee" [disableControl]="form.controls.id_franchisor.value != ''">
                                    <option value="">Keine Auswahl</option>
                                    <option *ngFor="let franchisee of franchisees" [ngValue]="franchisee.id">
                                        {{ franchisee.name }}
                                    </option>
                                </select>
                            </div>
                        } @else {
                            <div class="col-6 col-lg-4">
                                <label>Zugeordnet</label>
                                <p>{{ form.value.assigned }} ({{ form.value.assigned_type }})</p>
                            </div>
                        }
                    </div>
                    <div class="row g-3 mb-2">
                        <div class="col-6 col-lg-4">
                            <label>Prefix</label>
                            <input type="text" class="form-control" formControlName="prefix" *ngIf="viewMode != ViewMode.VIEW">
                            <p *ngIf="viewMode == ViewMode.VIEW" class="mb-0">{{ form.value.prefix }}</p>
                        </div>
                        <div class="col-6 col-lg-4">
                            <label>Startnummer</label>
                            <input type="number" class="form-control" formControlName="start" *ngIf="viewMode == ViewMode.INSERT">
                            <p *ngIf="viewMode != ViewMode.INSERT" class="mb-0">{{ form.value.start }}</p>
                        </div>
                        <div class="col-6 col-lg-4">
                            <label>E-Mail</label>
                            <input type="text" class="form-control" formControlName="email" *ngIf="viewMode != ViewMode.VIEW">
                            <p *ngIf="viewMode == ViewMode.VIEW" class="mb-0">{{ form.value.email }}</p>
                        </div>
                    </div>
                    <div class="row g-3 mb-2">
                        <div class="col-12 col-lg-4">
                            <label>IBAN</label>
                            <input type="text" class="form-control" formControlName="iban" *ngIf="viewMode != ViewMode.VIEW">
                            <p *ngIf="viewMode == ViewMode.VIEW" class="mb-0">{{ form.value.iban }}</p>
                        </div>
                        <div class="col-12 col-lg-4">
                            <label>BIC</label>
                            <input type="text" class="form-control" formControlName="bic" *ngIf="viewMode != ViewMode.VIEW">
                            <p *ngIf="viewMode == ViewMode.VIEW" class="mb-0">{{ form.value.bic }}</p>
                        </div>
                    </div>
                    <div class="row g-3">
                        <div class="col-12 col-lg-6">
                            <label>Rechnungskopf</label>
                            <input class="form-control" formControlName="header" *ngIf="viewMode != ViewMode.VIEW"/>
                            <p *ngIf="viewMode == ViewMode.VIEW" class="mb-0">
                                {{ form.value.header }}
                                <span class="text-muted" *ngIf="!form.value.header">Nicht gesetzt</span>
                            </p>
                        </div>
                        <div class="col-12 col-lg-6">
                            <label>Betreff</label>
                            <textarea type="text" class="form-control" formControlName="subject" *ngIf="viewMode != ViewMode.VIEW"></textarea>
                            <p *ngIf="viewMode == ViewMode.VIEW" class="mb-0">
                                {{ form.value.subject }}
                                <span class="text-muted" *ngIf="!form.value.subject">Nicht gesetzt</span>
                            </p>
                        </div>
                    </div>
                </form>

                <div class="mt-3">
                    @if (viewMode == ViewMode.VIEW) {
                        <button type="button" class="btn btn-primary me-2" (click)="setMode(ViewMode.EDIT)">Bearbeiten</button>
                        <button type="button" class="btn btn-secondary" (click)="cancel()">Zurück</button>
                        <!--<button type="button" class="btn btn-danger float-end" (click)="delete()">Löschen</button>-->
                    } @else if (viewMode == ViewMode.EDIT) {
                        <button type="button" class="btn btn-primary" [disabled]="form.invalid" (click)="update()">Aktualisieren</button>
                        <button type="button" class="btn btn-secondary ms-2" (click)="cancelEdit()">Abbrechen</button>
                    } @else if (viewMode == ViewMode.INSERT) {
                        <button type="button" class="btn btn-primary" [disabled]="form.invalid" (click)="save()">Speichern</button>
                        <button type="button" class="btn btn-secondary ms-2" (click)="cancel()">Abbrechen</button>
                    }
                </div>

            </div>
        </div>
    `
})
export class InvoiceTypeDetailComponent implements OnInit {

    accessService = inject(AccessService);
    private router = inject(Router);
    private fb = inject(UntypedFormBuilder);
    private dataService = inject(DataService);
    private route = inject(ActivatedRoute);
    private toastrService = inject(ToastrService);

    ViewMode = ViewMode;

    form!: UntypedFormGroup;
    id_invoice_type!: string;
    viewMode!: ViewMode;
    invoiceType: any;

    franchisors: any[] = [];
    franchisees: any[] = [];

    loading = false;

    ngOnInit(): void {
        this.id_invoice_type = this.route.snapshot.paramMap.get('id') ?? '0';
        this.viewMode = this.id_invoice_type == '0' ? ViewMode.INSERT : ViewMode.VIEW;

        this.form = this.fb.group({
            id: [null],
            id_franchisor: [''],
            id_franchisee: [''],
            name: ['', Validators.required],
            prefix: ["{{year}}", Validators.required],
            start: [null, Validators.required],
            email: [null, Validators.required],
            iban: [null, Validators.required],
            bic: [null, Validators.required],
            header: [null],
            subject: [null],

            assigned: [null],
            assigned_type: [null],
        });

        if (this.id_invoice_type !== '0') {
            this.getInvoiceType();
        }

        this.dataService.request("Franchisor/listForSelection").subscribe(response => {
            this.franchisors = response.franchisors;
        });

        this.dataService.request("Franchisee/listForSelection").subscribe(response => {
            this.franchisees = response.franchisees;
        });
    }

    getInvoiceType(): void {
        this.dataService.request('InvoiceType/get', {
            id_invoice_type: this.id_invoice_type
        }).subscribe(response => {
            this.invoiceType = response.type;

            this.patchForm();
        });
    }

    patchForm(): void {
        this.form.patchValue({
            id: this.invoiceType.id,
            id_franchisor: this.invoiceType.id_franchisor ?? '',
            id_franchisee: this.invoiceType.id_franchisee ?? '',
            name: this.invoiceType.name,
            prefix: this.invoiceType.prefix,
            start: this.invoiceType.start,
            email: this.invoiceType.email,
            iban: this.invoiceType.iban,
            bic: this.invoiceType.bic,
            header: this.invoiceType.header,
            subject: this.invoiceType.subject,
            assigned: this.invoiceType.assigned,
            assigned_type: this.invoiceType.assigned_type,
        });
    }

    save(): void {
        this.dataService.request('InvoiceType/save', {
            invoiceType: this.form.getRawValue(),
        }).subscribe(() => {
            this.router.navigate(['/invoicetype']);
            this.toastrService.success('Der Rechnungskreis wurde angelegt');
        });
    }

    update(): void {
        this.dataService.request('InvoiceType/update', {
            invoiceType: this.form.getRawValue(),
        }).subscribe(() => {
            this.setMode(ViewMode.VIEW);
            this.getInvoiceType();
            this.toastrService.success('Der Rechnungskreis wurde aktualisiert');
        });
    }

    cancel(): void {
        this.router.navigate(['/invoicetype']);
    }

    setMode(viewMode: ViewMode): void {
        this.viewMode = viewMode;
    }

    cancelEdit(): void {
        this.patchForm();
        this.setMode(ViewMode.VIEW);
        this.getInvoiceType();
    }

    delete(): void {
        Swal.fire({
            title: 'Sicher?',
            text: 'Der Rechnungskreis wird gelöscht.',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#DD6B55',
            confirmButtonText: 'Ja',
            cancelButtonText: 'Nein'
        }).then(result => {
            if (result.value) {
                this.dataService.request('InvoiceType/delete', {
                    id_invoice_type: this.id_invoice_type
                }).subscribe(() => {
                    this.cancel();
                    this.toastrService.success('Der Rechnungskreis wurde gelöscht');
                });
            }
        });
    }
}
